import { useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

export const useAuthSearchParams = () => {
  return useMemo(() => {
    const urlParams = new URLSearchParams(location.search)

    return {
      redirectUrl: urlParams.get('redirect_to') ?? undefined,
      inviteToken: urlParams.get('invite_token') ?? undefined,
      oauthEmail: urlParams.get('oauth_email') ?? undefined,
    }
  }, [location.search])
}

export const useRedirect = () => {
  const navigate = useNavigate()
  return useCallback(
    (url: string) => {
      if (url.startsWith('http')) {
        window.location.href = url
      } else {
        navigate(url)
      }
    },
    [navigate]
  )
}
